/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jade_Teal_Rat_ReadInputs */

const en_jade_teal_rat_read = /** @type {(inputs: Jade_Teal_Rat_ReadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job details`)
};

const de_jade_teal_rat_read = /** @type {(inputs: Jade_Teal_Rat_ReadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import-Details`)
};

/**
* | output |
* | --- |
* | "Job details" |
*
* @param {Jade_Teal_Rat_ReadInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const jade_teal_rat_read = /** @type {((inputs?: Jade_Teal_Rat_ReadInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jade_Teal_Rat_ReadInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_jade_teal_rat_read(inputs)
	return de_jade_teal_rat_read(inputs)
});